import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function UnsubscribersIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 36} height={height || 36} viewBox="0 0 36 36">
      <g
        data-name="Ellipse 76"
        transform="translate(0 -.045) translate(0 .045)"
        fill="none"
        stroke={color || "#bbb"}
        strokeWidth={1.5}
      >
        <circle cx={18} cy={18} r={18} stroke="none" />
        <circle cx={18} cy={18} r={17.25} />
      </g>
      <path
        data-name="Union 9"
        d="M0 8a8 8 0 118 8 8.009 8.009 0 01-8-8zm1.846 0A6.154 6.154 0 108 1.846 6.162 6.162 0 001.846 8zm2.769.924a.923.923 0 110-1.846h6.77a.923.923 0 110 1.846z"
        transform="translate(0 -.045) translate(10.128 9.62)"
        fill={color || "#bbb"}
      />
    </svg>
  );
}
